import React from 'react';

import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useSetRecoilState } from 'recoil';

import { getAxiosErrorOrThrow } from 'shared/utils/error';
import { updateProfile } from 'modules/marketing-profile/api';
import { useGuaranteedAuth } from 'shared/hooks/useAuth';
import { IUpdateMarketingProfile } from 'modules/marketing-profile/models/marketing-profile';
import { registerUser } from 'modules/user/api/user';
import { userInsertSelector } from 'modules/user/state/user-insert';
import {useMarketingProfileAsUser} from 'modules/marketing-profile/hooks/useMarketingProfileAsUser';
import { TeacherRegistrationInfo } from 'users/pages/UserRegistration/TeacherRegistrationForm/TeacherRegistrationInfo';

export const TeacherRegistrationForm = () => {
    const {t} = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    const {tokenData, tenantId} = useGuaranteedAuth();

    const profile = useMarketingProfileAsUser(tenantId, tokenData.id);

    const insertUser = useSetRecoilState(userInsertSelector);

    const onSubmit = (data: IUpdateMarketingProfile) => {
        if (!profile?.id || isSubmitting) {
            return;
        }
        if (!data.accept_terms) {
            toast.error(t(
                'userInfoForm.form.registerError',
                'You must accept the terms and conditions to use the platform',
            ));
        }
        setIsSubmitting(true);
        (async () => {
            try {
                await updateProfile(tenantId, profile.id, data);
                const updatedUser = await registerUser(tenantId, tokenData.id);
                insertUser(updatedUser);
            } catch (e) {
                toast.error(getAxiosErrorOrThrow(e));
            } finally {
                setIsSubmitting(false);
            }
        })();
    };
    
    return (
        <Container fluid className="d-flex vh-100">
            <Row className="m-auto align-self-center w-100">
                <Col xs={12} md={6} lg={6} className="mx-auto">
                    <h1 style={{textAlign: 'center', marginTop: '20px', marginBottom: '20px'}}>
                        {t('teacherRegistrationForm.form.title', 'Teacher Registration Form')}
                    </h1>
                    <TeacherRegistrationInfo
                        isSubmitting={isSubmitting}
                        onSubmit={onSubmit}
                    />
                </Col>
            </Row>
        </Container>
    );
};